import {connect} from "react-redux";

import {list} from "../../redux/users/userActions";
import UsersPage from "./UsersPage";

const mapStateToProps = ({users}) => ({
	users: users.list
});

const mapDispatchToProps = {
	listUsers:list
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);